import { useMemo } from 'react';

import type { UseShareActionsOptions } from '#src/app/shared/hooks/share';

import { useGetShareContent } from './useGetShareContent';
import { useGetShareTrackingData } from './useGetShareTrackingData';

export function useShareOptions(): UseShareActionsOptions {
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();

	return useMemo(
		() => ({
			trackingEventName: 'share_petition_guides_article',
			getContent,
			getTrackingData,
		}),
		[getContent, getTrackingData],
	);
}
